import React from "react"
import { ChangeEvent, FC } from "react"
import { Form } from "react-bootstrap"
import { AiOutlineClose, AiOutlineSearch } from "react-icons/ai"

import "./styles.scss"
type Props = {
  textSearch: string,
  handleChangeName: (event: ChangeEvent<HTMLInputElement>) => void,
  cleanSearch: () => void,
  placeholder?: string
}
const InputFilter: FC<Props> = ({ textSearch, handleChangeName, cleanSearch, placeholder = 'Pesquisar por nome...' }) => {
  return (
    <div className="input-filter">
      <div className="searchInfo">
        <AiOutlineSearch />
        <Form.Control
          id="searchInput"
          value={textSearch}
          onChange={handleChangeName}
          placeholder={placeholder}
        />
        {textSearch && <button
          className="cleanSearch"
          onClick={cleanSearch}
        >
          <AiOutlineClose />
        </button>}
      </div>
    </div>
  )
}

export default InputFilter
